<script lang="ts" setup>
const props = withDefaults(defineProps<{
    width?: number | number[];
    height?: number;
    percent?: boolean;
    image?: boolean;
}>(), {
    width: 100,
    height: 17
});

const unit = computed(() => props.percent !== false ? '%' : 'px');
const getHeight = computed(() => props.height);
const getWidth = computed(() =>
{
    if (Array.isArray(props.width) && props.width.length == 2)
        return Math.floor(Math.random() * (props.width[1] - props.width[0] + 1)) + props.width[0];
    else if (Array.isArray(props.width))
        return props.width[Math.floor(Math.random() * props.width.length)];

    return props.width;
});
</script>

<template>
    <div class="placeholder placeholder-wave bg-secondary d-inline-block" :class="{ 'img': image }" :style="`width: ${getWidth}${unit}; height: ${getHeight}px`" />
</template>
